"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const StaffIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 20 20" }),
    react_1.default.createElement("g", { transform: "translate(2,1)" },
        react_1.default.createElement("path", { d: "M8 4C8 5.65685 6.65685 7 5 7C3.34315 7 2 5.65685 2 4C2 2.34315 3.34315 1 5 1C6.65685 1 8 2.34315 8 4Z" }),
        react_1.default.createElement("path", { d: "M0 11C0 9.63344 0.913723 8.48029 2.16356 8.11816C2.9695 8.67432 3.94671 9.00001 5 9.00001C6.05329 9.00001 7.0305 8.67432 7.83644 8.11816C9.08628 8.48029 10 9.63344 10 11V15H0V11Z" }),
        react_1.default.createElement("path", { d: "M11.9999 11C11.9999 10.6571 11.9654 10.3222 11.8997 9.99875C11.933 9.99957 11.9664 9.99998 11.9999 9.99998C12.8476 9.99998 13.6338 9.73626 14.2808 9.28638C15.297 9.76686 15.9999 10.8013 15.9999 12V15H11.9999V11Z" }),
        react_1.default.createElement("path", { d: "M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z" }))));
exports.StaffIcon = StaffIcon;
exports.default = exports.StaffIcon;
